import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import classNames from 'classnames/bind'
import styles from './NavbarItem.module.scss'
import { INavbarItem } from '../../Navbar.component'
import { Link, useLocation } from 'react-router-dom'
import { currentTheme, drawerSetting, setDrawerSetting } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { useDispatch } from 'react-redux'

const cx = classNames.bind(styles)

interface INavbarItemProps {
  navItem: INavbarItem
  validRole: boolean
  isMobile?: boolean
}
export const NavbarItem = ({ navItem, validRole, isMobile }: INavbarItemProps) => {
  const theme = useAppSelector(currentTheme)
  const location = useLocation()
  const dispatch = useDispatch()
  const { isShowDrawer } = useAppSelector(drawerSetting)
  return (
    <ListItem
      key={navItem.name}
      title={navItem.name}
      disablePadding
      className={cx(
        'nav-item',
        theme,
        {
          hide: !validRole
        },
        {
          active: location.pathname.startsWith(navItem.path)
        }
      )}
    >
      <Link
        className={cx('nav-link')}
        to={navItem.path}
        target={navItem.name === 'Help' ? '_blank' : '_self'}
        rel='noopener noreferrer'
      >
        <ListItemButton
          className={cx('nav-link-button')}
          onMouseUp={() => {
            if (isMobile) dispatch(setDrawerSetting({ isShowDrawer: false }))
          }}
        >
          <ListItemIcon className={cx('nav-link-icon')}>
            <navItem.icon height={34} width={34} />
            {isShowDrawer && (
              <ListItemText
                primary={navItem.name}
                className={cx('navbar-item-text', theme)}
              />
            )}
          </ListItemIcon>
        </ListItemButton>
      </Link>
    </ListItem>
  )
}
